export enum AreaTriggerType {
    IN = 'in',
    OUT = 'out',
}

export enum CustomerTriggerType {
    ARRIVAL = 'arrival',
    DEPARTURE = 'departure',
}
